import { Directive, EventEmitter, Input, Output } from '@angular/core';

@Directive()
export abstract class TicketCreateButtonBaseComponent {
  @Output() tapped = new EventEmitter();
  @Input() text: string;
  @Input() noContract = false;
}
